import {
  GET_DATA,
  GET_DATA_SUCCESS,
  GET_DATA_FAIL,
  SET_PAGE,
  CLEAR_DATA,
  CLEAR_DATA_SUCCESS
} from "./actionTypes";

export const getData = (url, page, length, filter) => ({
  type: GET_DATA,
  payload: { url, page, length, filter }
});
export const getDataSuccess = data => ({
  type: GET_DATA_SUCCESS,
  payload: data,
});
export const getDataFail = error => ({
  type: GET_DATA_FAIL,
  payload: error,
});

export const setPage = (page, length) => ({
  type: SET_PAGE,
  payload: { page, length }
});

export const clearData = () => ({
  type: CLEAR_DATA
});

export const clearDataSuccess = () => ({
  type: CLEAR_DATA_SUCCESS
});